import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from '@ckeditor/ckeditor5-utils';
import { catchError, firstValueFrom, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KeycloakAuthService  {

  keycloakUrl = environment.sbmsUrl + "/verify-jwt";

  constructor(private http: HttpClient) { }

  private loggedIn?: boolean;

  logout(){
    this.loggedIn = false;
  }

  async isLoggedIn(): Promise<boolean>{
    if(this.loggedIn === true){
      return true;
    }

    try{
      const response = await firstValueFrom(this.http.get<{loggedIn: boolean}>(this.keycloakUrl, {withCredentials: true, responseType: 'text' as 'json'})); 
      this.loggedIn = true;
      return true;
    } catch(error: any){
      this.loggedIn = false;
      if(error.status === 401){
        console.log("Unauthorized");
      } else {
        console.log("Error checking login: " + error.message);
      }
      return false;
    }
  }
}
